import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { Dispatch, FC, SetStateAction, useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { AssignIcon } from '../../vectors/index';
import AssignTagsModal from '@features/applications/components/AssignTagsModal/AssignTagsModal';
import EmployerAssignTagsModal from '@features/applications/components/EmployerAssignTagsModal/EmployerAssignTagsModal ';
import { authContext } from '@staffedupusa/shared-components';
import { Application } from '@features/applications';

type AssigningTagMainModalProps = {
    isAssignTagModalOpen: boolean;
    handleClose: () => void;
    setApplicationData?: Dispatch<SetStateAction<Application[] | null>>;
    setApplication?: Dispatch<SetStateAction<Application | null>>;
    applicationId?: number;
    selectedCompanyId?: string | number;
    templateId?: number;
    manageTags?: boolean;
};

const AssigningTagMainModal: FC<AssigningTagMainModalProps> = ({
    isAssignTagModalOpen,
    handleClose,
    setApplicationData,
    setApplication,
    applicationId,
    templateId,
    selectedCompanyId,
    manageTags,
}) => {
    const { authData } = useContext(authContext);
    return (
        <Dialog
            open={isAssignTagModalOpen}
            onClose={handleClose}
            maxWidth={'xs'}
            fullWidth
            disableEnforceFocus
        >
            <DialogTitle>
                <IconButton
                    sx={{ position: 'absolute', top: 5, right: 5 }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
                <br />
                <AssignIcon />
                <br />
                <Typography variant="h4" sx={{ p: 3 }}>
                  {manageTags ? 'Manage Tags' : ' Assign Tags'} 
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={3}>
                    <>
                        {authData.user?.company || templateId ? (
                             <EmployerAssignTagsModal
                                handleClose={handleClose}
                                setApplicationData={setApplicationData}
                                selectedApplicationsIds={applicationId ? [applicationId] : []}
                                setApplication={setApplication}
                                manageTags={manageTags}
                                templateId={templateId}
                            />
                        ) : (
                            <AssignTagsModal
                                handleClose={handleClose}
                                setApplicationData={setApplicationData}
                                selectedApplicationsIds={applicationId ? [applicationId] : []}
                                setApplication={setApplication}
                                selectedCompanyId={selectedCompanyId}
                            />
                        )}
                    </>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default AssigningTagMainModal;
